// src/components/Auth.vue
<template>
  <div class="auth">
    <amplify-authenticator v-bind:authConfig="authConfig"></amplify-authenticator>
  </div>
</template>

<script>
  export default {
    name: 'Auth',
    data() {
        return {
            authConfig: {
                usernameAttributes: 'email',
                signUpConfig: {
                    header: 'Create DataZone Industry account',
                    defaultCountryCode: '42',
                    hideAllDefaults: true,
                    signUpFields: [
                      {
                        label: 'Email',
                        key: 'email',
                        required: true,
                        displayOrder: 1,
                        type: 'string',
                        signUpWith: true
                      },
                      {
                        label: 'Password',
                        key: 'password',
                        required: true,
                        displayOrder: 2,
                        type: 'password'
                      }
                    ]
                }
            }
        }
    }
}

</script>

<style>
.auth {
  margin: 0 auto;
  width: 460px;
}
</style>